import { render, staticRenderFns } from "./CollectedItem.vue?vue&type=template&id=68726356&scoped=true"
import script from "./CollectedItem.vue?vue&type=script&lang=js"
export * from "./CollectedItem.vue?vue&type=script&lang=js"
import style0 from "./CollectedItem.vue?vue&type=style&index=0&id=68726356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68726356",
  null
  
)

export default component.exports